import React, { ChangeEvent, FC, InputHTMLAttributes } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

interface DropdownOption {
  label: string;
  value: string;
}

interface InputWithDropdownProps {
  value: string;
  onInputChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  selectedDropdownValue: string;
  onDropdownChange: (value: string) => void;
  dropdownOptions: DropdownOption[];
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  label?: string;
}

const InputWithDropdown: FC<InputWithDropdownProps> = ({
  value,
  onInputChange,
  selectedDropdownValue,
  onDropdownChange,
  dropdownOptions,
  inputProps,
  label,
}) => {
  return (
    <div>
      {label && (
        <h6 className="text-[13px] text-muted-foreground font-normal mb-1 pl-1">
          {label}
        </h6>
      )}
      <div className="flex items-center p-[5px] !bg-background !border-border rounded-xl overflow-hidden">
        <input
          {...inputProps}
          value={value}
          onChange={onInputChange}
          className="flex-grow min-w-0 px-3 py-2 h-[38px] bg-transparent placeholder-gray-500 outline-none"
        />
        <Select onValueChange={onDropdownChange} value={selectedDropdownValue}>
          <SelectTrigger className="!bg-primary !text-white border-none">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-primary text-primary-foreground">
            <SelectGroup className="bg-primary text-primary-foreground">
              {dropdownOptions.map(({ label, value }) => (
                <SelectItem key={value} value={value}>
                  {label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default InputWithDropdown;
